import styled from "styled-components";

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 24px;
  padding: 20px;
  width: 320px;
  height: auto;
  gap: 16px;
  overflow: auto;

  @media only screen and (min-width: 769px) {
    width: 353px;
    padding: 24px;
    gap: 24px;
  }
`;

export const TextHead = styled.p`
  color: #1f2d3d;
  margin: 0;
  font-size: 20px;
  line-height: 29px;
  font-weight: bold;

  @media only screen and (min-width: 769px) {
    font-size: 24px;
    line-height: 35px;
  }
`;

export const TextRegular = styled.p`
  margin: 0;
  font-size: ${(props) => props?.fontSize ?? "13px"};
  line-height: 19px;
  color: #6a7481;

  @media only screen and (min-width: 769px) {
    font-size: ${(props) => props?.fontSize ?? "16px"};
    line-height: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 40px;
  background-color: #00bcf1;

  margin-top: 16px;
  @media only screen and (min-width: 768px) {
    max-width: 327px;
    margin-top: 24px;
  }
`;

export const ContainerInput = styled.div`
  border-radius: 4px;
  border: 1px solid #b8c1cb;
  height: 40px;
  padding: 8px 4px;
  display: flex;
`;

export const ContainerAlert = styled.div`
  display: flex;
  align-items: center;
  background-color: #ffe7e1;
  border-radius: 8px;
  border: 1px solid #af183c;
  height: 32px;
  padding: 8px 4px;
`;

export const Input = styled.input`
  border: none;
  margin-left: 8px;
  height: 24px;
  width: 80%;
  max-width: 300px;
  font-size: 13px;

  @media only screen and (min-width: 768px) {
    max-width: px;
  }
`;
